var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLamp401({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12.14,
    y: 2.82,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 1.6193 10.0435)",
    className: "st2",
    width: 1.58,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.28,
    y: 12.68,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -8.2469 5.9568)",
    className: "st2",
    width: 1.58,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12.62,
    y: 12.17,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -5.3294 12.8663)",
    className: "st2",
    width: 0.5,
    height: 1.39
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.82,
    y: 2.28,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -1.2704 3.067)",
    className: "st2",
    width: 0.5,
    height: 1.58
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8,13.74c-3.17,0-5.74-2.58-5.74-5.74c0-3.17,2.58-5.74,5.74-5.74c3.17,0,5.74,2.58,5.74,5.74 C13.74,11.17,11.17,13.74,8,13.74z M8,2.76C5.11,2.76,2.76,5.11,2.76,8S5.11,13.24,8,13.24s5.24-2.35,5.24-5.24S10.89,2.76,8,2.76 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp401);
export default __webpack_public_path__ + "static/media/Lamp4-01.427238da0eed06af69bce34cade11c11.svg";
export { ForwardRef as ReactComponent };